import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.css']
})
export class SearchBoxComponent implements OnInit {
    @Input() searchInput: string;

    constructor(private router: Router) { }

    ngOnInit() {
    }


    onEnter(): void {
        this.router.navigate(['/search'], { queryParams: { 'q': this.searchInput }});
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/search-box/search-box.component.ts